import { Component, OnInit, OnDestroy } from '@angular/core';
import { UiService } from '../../ui.service';
import { AppServiceService } from '../../app-service.service';
import { collectionPage } from '../../animation/animate';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { WindowService } from '../../window.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
  animations: [
    collectionPage
  ],
  host: { '[@collectionPage]': '' }
})
export class BlogComponent implements OnInit, OnDestroy {

  private ngUnsubscribe: Subject<boolean> = new Subject();
  cursorX:any = '50%';
  cursorY:any = '50%';
  post:any;
  collections:any;
  public screen:any = { 
    'width' : '1920',
    'height': '1080'
  };

  constructor(
    private UI:UiService, 
    private app:AppServiceService, 
    private router:Router,
    private route: ActivatedRoute,
    private window: WindowService
  ) {   
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.post = data.data;
    });

    //take propery position anim
    this.cursorX = this.app.cursorX;
    this.cursorY = this.app.cursorY;

    this.app.arrow.next(true);
    this.app.externalButton.next(false);
    //menu
    this.app.blackStyle.next(true);
    this.app.normalMenu.next(true); 
  }

  getRoute(url:string){
    let mass = url.split('/');
    return mass[mass.length - 1];
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

  getCoodsColect(event){
    let element:any = {};
    let bounds = event.target.getBoundingClientRect();
    element.width = bounds.width+'px';
    element.height = bounds.height+'px';
    element.x = bounds.left;
    element.y = bounds.top;
    this.app.element = element;
  }

  moveTo(event:Event, link){
    event.preventDefault();
    event.stopPropagation();
    this.router.navigate(['blog',link]);
  }

  ngAfterViewInit(){
    this.window.removeMainSlider(); 
  }

  ngOnInit() {  
    //screen
    this.screen = this.app.screen;
    this.app.screenSubject.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      this.screen = this.app.screen;
    })
    setTimeout(() => {
      this.UI.slideCollection('#blog-slider');
      this.app.showLeftPanel.next(true);
    }, 800);
    setTimeout(() => {
      this.app.title.next(this.post.title);
      this.app.titleLeftPanel.next(true);
      this.app.activeMenu.next(true);
    }, 1200);
  }

  ngOnDestroy(){
    this.app.titleLeftPanel.next(false);
    this.app.blackStyle.next(false);
    this.app.activeMenu.next(false);

    //menu
    this.app.menuState.next('hide');
    this.app.submenuState.next('hide');

    setTimeout(() => {
      this.app.title.next('');
    }, 500);

    //unsabscribe
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/blog/blog/blog.component.ts